var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48233 4.84398C4.36445 4.8446 4.24759 4.82425 4.13845 4.7841C4.02932 4.74395 3.93006 4.68479 3.84636 4.61002L0.263428 1.3829C0.179911 1.30767 0.113662 1.21837 0.0684629 1.12009C0.0232639 1.0218 1.75999e-09 0.916463 0 0.810081C-1.75999e-09 0.7037 0.0232639 0.59836 0.0684629 0.500076C0.113662 0.401792 0.179911 0.31249 0.263428 0.237267C0.346944 0.162044 0.446093 0.102374 0.555213 0.0616633C0.664333 0.0209529 0.781288 -1.58521e-09 0.899398 0C1.01751 1.58521e-09 1.13446 0.0209528 1.24358 0.0616633C1.3527 0.102374 1.45185 0.162044 1.53537 0.237267L4.48233 2.90771L7.43825 0.342149C7.52065 0.259623 7.62107 0.193299 7.73323 0.147324C7.84538 0.101348 7.96687 0.0767114 8.09008 0.0749532C8.21329 0.073195 8.33558 0.0943529 8.4493 0.137105C8.56301 0.179857 8.66571 0.243284 8.75097 0.323417C8.83624 0.40355 8.90222 0.498666 8.94481 0.602816C8.9874 0.706967 9.00566 0.817912 8.99847 0.928712C8.99128 1.03951 8.95879 1.14778 8.90302 1.24676C8.84725 1.34573 8.76941 1.43327 8.67436 1.50391L5.09143 4.61809C4.92762 4.76033 4.70985 4.8411 4.48233 4.84398Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.18218b7463f34831aaee5db25afdc176.svg";
export { ForwardRef as ReactComponent };